/**
 * Affiche une gamme de tailles comme "Titre (S-_-L) (3)" ou "S-_-L (3)".
 * Le chiffre final correspond à la position de la dernière colonne renseignée.
 * Les colonnes vides intermédiaires sont matérialisées par "_" pour éviter de
 * décaler visuellement les tailles suivantes.
 */
export function getDeclinaisonLength(
  tailles: string | string[] | null | undefined,
): number {
  const allSizes = Array.isArray(tailles)
    ? tailles.map((size) => String(size ?? "").trim())
    : String(tailles ?? "")
        .split(",")
        .map((size) => size.trim());

  return allSizes.reduce(
    (length, size, index) => (size !== "" ? index + 1 : length),
    0,
  );
}

export function formatDeclinaisonLabel(
  titre: string | null | undefined,
  tailles: string | string[] | null | undefined,
): string {
  let title = (titre ?? "").trim();

  const allSizes = Array.isArray(tailles)
    ? tailles.map((size) => String(size ?? "").trim())
    : String(tailles ?? "")
        .split(",")
        .map((size) => size.trim());

  const sizesList = allSizes.slice(0, getDeclinaisonLength(allSizes));

  const count = sizesList.length;
  const sizes = sizesList.map((size) => size || "_").join("-");
  const countSuffix = count > 0 ? ` (${count})` : "";

  // Idempotent : retirer un éventuel "(N)" déjà présent en fin de libellé
  title = title.replace(/\s*\(\d+\)\s*$/, "").trim();

  if (!title) {
    return sizes ? `${sizes}${countSuffix}` : "";
  }
  if (!sizes) {
    return title;
  }

  const titleLower = title.toLowerCase();
  if (
    titleLower.includes(sizes.toLowerCase()) ||
    titleLower.includes(sizesList.join(",").toLowerCase())
  ) {
    return `${title}${countSuffix}`;
  }

  return `${title} (${sizes})${countSuffix}`;
}
